import { TextField } from "@mui/material";
import Flex from "./Flex";
import { inputLabel } from "./MaskInput";
import { useFieldLock } from "./ReadOnlyFields";
import Text from "./Text";
import { DEFAULT_FONTSIZE } from "@/utils/utils";
import {
  LegacyTextFieldProps,
  normalizeTextFieldProps,
} from "@/utils/text-field-props";

type CustomTextAreaProps = {
  minRows?: number;
  label?: string;
  required?: boolean;
} & LegacyTextFieldProps;

export default function CustomTextArea({
  label,
  required,
  minRows,
  ...others
}: CustomTextAreaProps) {
  const tf = normalizeTextFieldProps(others);
  const lock = useFieldLock(tf.disabled);
  const callerInputSlot =
    tf.slotProps?.input && typeof tf.slotProps.input === "object"
      ? tf.slotProps.input
      : undefined;

  return (
    <Flex width={"100%"} flexDirection={"column"}>
      {/* <Typography mb={"10px"} sx={DEFAULT_FONTSIZE}>
        {label}
        {others.required && (
          <Typography component={"span"} color={"error"}>{` *`}</Typography>
        )}
      </Typography> */}

      <Flex flexDirection={"column"} gap={1} width={"100%"}>
        <TextField
          sx={{
            "& .MuiInputBase-input": { ...DEFAULT_FONTSIZE },
          }}
          label={inputLabel(label, required)}
          multiline={tf.multiline ?? true}
          fullWidth
          rows={minRows}
          {...tf}
          disabled={lock.disabled}
          slotProps={{
            ...tf.slotProps,
            input: {
              ...callerInputSlot,
              readOnly: lock.readOnly || !!callerInputSlot?.readOnly,
            },

            inputLabel: { shrink: true },
          }}
        />

        {!!tf.error && (
          <Text fontSize={"13px"} variant="caption" color="error">
            {tf.error}
          </Text>
        )}
      </Flex>
    </Flex>
  );
}
